import { render, staticRenderFns } from "./wxAccountSelector.vue?vue&type=template&id=70e86d0c"
import script from "./wxAccountSelector.vue?vue&type=script&lang=js"
export * from "./wxAccountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports